import { render, staticRenderFns } from "./ButtonPrimary.vue?vue&type=template&id=e6134a0e&scoped=true"
import script from "./ButtonPrimary.vue?vue&type=script&lang=js"
export * from "./ButtonPrimary.vue?vue&type=script&lang=js"
import style0 from "./ButtonPrimary.vue?vue&type=style&index=0&id=e6134a0e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6134a0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6134a0e')) {
      api.createRecord('e6134a0e', component.options)
    } else {
      api.reload('e6134a0e', component.options)
    }
    module.hot.accept("./ButtonPrimary.vue?vue&type=template&id=e6134a0e&scoped=true", function () {
      api.rerender('e6134a0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/atoms/ButtonPrimary.vue"
export default component.exports